import { jsx as _jsx } from "react/jsx-runtime";
import { useRouter } from '@tribeplatform/react-sdk';
import { Button } from '@tribeplatform/react-ui-kit/Button';
export const ButtonView = ({ value, text, }) => {
    const { Link } = useRouter();
    if (!value || !text) {
        return null;
    }
    return (_jsx(Button, { as: Link, href: value, size: "lg", fullWidth: true, onClick: e => e.stopPropagation(), children: text }, void 0));
};
//# sourceMappingURL=ButtonView.js.map